/* esm.sh - react-router@8.4.0/dist/production/lib/router/url */
var r=/^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i,t=/^[\\/]{2}/;function E(o,e){return e+o.replace(/\\/g,"/")}export{r as ABSOLUTE_URL_REGEX,t as PROTOCOL_RELATIVE_URL_REGEX,E as normalizeProtocolRelativeUrl};
/*! Bundled license information:

react-router/dist/production/lib/router/url.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=url.mjs.map